export var BookingParamNames;
(function (BookingParamNames) {
    BookingParamNames["PickUpId"] = "pid";
    BookingParamNames["PickUpDate"] = "pdate";
    BookingParamNames["PickUpTime"] = "ptime";
    BookingParamNames["DropOffId"] = "did";
    BookingParamNames["DropOffDate"] = "ddate";
    BookingParamNames["DropOffTime"] = "dtime";
    BookingParamNames["PCountryCode"] = "pCountryCode";
    BookingParamNames["TravelType"] = "travelType";
    BookingParamNames["Age"] = "age";
    BookingParamNames["SippCode"] = "sippCode";
    BookingParamNames["Ancillaries"] = "ancillaries";
    BookingParamNames["RateQuoteIds"] = "rateQuoteIds";
    BookingParamNames["IataNumber"] = "IATA";
    // discount codes
    BookingParamNames["CdpDiscountCode"] = "CDP";
    BookingParamNames["CvDiscountCode"] = "CV";
    BookingParamNames["ItDiscountCode"] = "IT";
    BookingParamNames["PcDiscountCode"] = "PC";
    BookingParamNames["RqDiscountCode"] = "RQ";
    BookingParamNames["ConfirmationNumber"] = "confirmationNumber";
    BookingParamNames["OwnershipType"] = "ownershipType";
    BookingParamNames["CdpToken"] = "cdpToken";
})(BookingParamNames || (BookingParamNames = {}));
